<template>
  <div class="header">
    <div class="headMain">
      <i class="logo"></i>
      <div class="right-infors">
        <ul class="tabBox">
          <li
            class="tabItem"
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: tabKey == item.id }"
          >
            <a href="javascript:void(0);" @click="changeTab(item.id)">
              {{ $Getlanguage(item.text) }}</a
            >
          </li>
        </ul>
        <div class="language-box">
          <select name="country" @change="changeLanguage" v-model="language">
            <option value="0">日本語</option>
            <option value="1">EngLish</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, nextTick } from "vue";
import { useStore } from "vuex";

const store = useStore();
const language = ref("0");
const changeLanguage = () => {
  store.dispatch("changeTransferText", language.value);
};
const tabList = [
  { text: "About US", id: "section1" },
  { text: "Opening Hours", id: "section2" },
  { text: "Reservation Consultation", id: "section3" },
  { text: "Menu", id: "section4" },
  { text: "Party Information", id: "section5" },
  { text: "Contact US", id: "section6" },
];
const tabKey = ref("section1");
let needAutoCalc = true; // 是否需要自动计算滚动
const changeTab = (id) => {
  needAutoCalc = false;
  tabKey.value = id;
  getScroll(id);
  localStorage.setItem("needScroolTabKey", id);
};
const disTop = 100;
const calcScroll = (current) => {
  if (!needAutoCalc) {
    return;
  }
  // 获取所有内容区域
  const sections = document.querySelectorAll("#app div[name]");
  // 检查每个内容区域的位置
  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    const sectionHeight = section.clientHeight;
    const sectionId = section.getAttribute("name");
    if (
      current >= sectionTop - disTop &&
      current < sectionTop + sectionHeight
    ) {
      // 如果当前滚动位置在某个内容区域内，则选中对应的锚点
      tabKey.value = sectionId;
    }
  });
};
const getScroll = async (scrollId) => {
  if (scrollId) {
    tabKey.value = scrollId;
    const sections = document.querySelector(`[name="${scrollId}"]`);
    // 检查每个内容区域的位置
    if (sections) {
      const sectionTop = sections.offsetTop;
      window.scrollTo({
        top: sectionTop - disTop,
        behavior: "smooth",
      });
      setTimeout(() => {
        needAutoCalc = true;
      }, 1000);
    }
  }
  return true;
};
let timers = null;
const watchPageScroll = () => {
  // 监听滚动事件
  window.addEventListener("scroll", () => {
    if (timers) {
      clearTimeout(timers);
    }
    timers = setTimeout(() => {
      // 获取当前滚动位置
      const current = window.scrollY;
      calcScroll(current);
    }, 200);
  });
};
const initSroll = async () => {
  const needScroolTabKey = localStorage.getItem("needScroolTabKey");
  if (needScroolTabKey) {
    await getScroll(needScroolTabKey);
    localStorage.removeItem("needScroolTabKey");
  }
  return true;
};
onMounted(async () => {
  language.value = store.state.isTransferTextStatus;
  // await initSroll();
  nextTick(() => {
    watchPageScroll();
  });
});
</script>
<style lang="scss" scoped>
ul {
  list-style: none;
}
.header {
  width: 100%;
  height: 62px;
  padding-top: 21px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 3;
  background: #000;
  .headMain {
    width: 100%;
    padding: 0 8.3%;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .logo {
    flex-shrink: 0;
    display: inline-block;
    width: 209px;
    height: 62px;
    background: url($imgUrl + "/logo.png?v=1") no-repeat center / cover;
  }
  .right-infors {
    display: flex;
    .language-box {
        position: relative;
        &::after {
            content: ''; /* 添加自定义字符 */
            display: inline-block;
            position: absolute;
            right: 10px; /* 调整位置 */
            top: 60%;
            transform: translateY(-50%);
            pointer-events: none; /* 使其不接收鼠标事件 */
            width: 0;
            height: 0;
            border: 5px solid transparent;
            border-top-color: #fff;
        }
        select {
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            border: none;
            outline: none;
            -webkit-appearance: none; /* 移除iOS默认样式 */
            -moz-appearance: none; /* 移除Firefox默认样式 */
            appearance: none; /* 移除标准浏览器默认样式 */
            position: relative;
            padding: 5px 30px 5px 5px;
            background: #000;
            border: 1px solid #fff;
            option {
                background: #000;
                &:checked {
                    font-weight: 700;
                }
                &:hover {
                    background: #000;
                }
            }
            }
        }
  }
  .tabBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .tabItem {
      text-align: center;
      word-break: break-word;
      margin: 0 20px;
      position: relative;
      cursor: pointer;
      margin: 0 18px;
      a {
        display: inline-block;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        text-decoration: none;
        white-space: nowrap;
      }
      &.active {
        a {
          font-weight: 700;
          color: #e2b281;
        }
      }
      &:hover {
        a {
          opacity: 0.85;
        }
      }
    }
  }
}
</style>